import ParamMngDef from "../pages/paramMng/ParamMngDef";
import echarts from 'echarts/lib/echarts';
import OperationLogMonitor from '../pages/tranLog/OperationLogMonitor'
import OperationLogStatistics from '../pages/tranLog/OperationLogStatistics'

import BatchTimeConfig from "../pages/thirdPartyComponents/BatchTimeConfig";

// 需要导出哪些自定义组件，写在这里，可以通过tool.createElement("key", props, children, true)来获取组件
let sgiCustomModule = {
	ParamMngDef: ParamMngDef,
	//echarts
	sgiEcharts: echarts,
	//工作台

	OperationLogMonitor,
	OperationLogStatistics,

	BatchTimeConfig
}

//给类添加公共方法
Object.assign(window.sgiCustomModule, sgiCustomModule);



// WEBPACK FOOTER //
// ./apps/conf/sgiCustomModule.js